export const logSpace = (min, max, steps) => {
  if (!(min > 0) || !(max > 0) || steps < 2) return [];
  const logMin = Math.log(min);
  const logMax = Math.log(max);
  const step = (logMax - logMin) / (steps - 1);
  const values = [];
  for (let i = 0; i < steps; i += 1) {
    values.push(Math.exp(logMin + step * i));
  }
  return values;
};

export const linSpace = (min, max, steps) => {
  if (!Number.isFinite(min) || !Number.isFinite(max) || steps < 2) return [];
  const step = (max - min) / (steps - 1);
  const values = [];
  for (let i = 0; i < steps; i += 1) {
    values.push(min + step * i);
  }
  return values;
};

export const linearRegression = (xs, ys) => {
  const n = xs.length;
  if (n < 2) return null;
  let sumX = 0;
  let sumY = 0;
  let sumXY = 0;
  let sumX2 = 0;

  for (let i = 0; i < n; i += 1) {
    const x = xs[i];
    const y = ys[i];
    sumX += x;
    sumY += y;
    sumXY += x * y;
    sumX2 += x * x;
  }

  const denominator = n * sumX2 - sumX * sumX;
  if (denominator === 0) return null;
  const slope = (n * sumXY - sumX * sumY) / denominator;
  const intercept = (sumY - slope * sumX) / n;
  return { slope, intercept };
};

export const computeSSE = (observed, predicted) => {
  let sum = 0;
  for (let i = 0; i < observed.length; i += 1) {
    const diff = observed[i] - predicted[i];
    sum += diff * diff;
  }
  return sum;
};

export const computeRSquared = (observed, predicted) => {
  const n = observed.length;
  if (n === 0) return null;
  const mean = observed.reduce((acc, value) => acc + value, 0) / n;
  let ssTot = 0;
  let ssRes = 0;
  for (let i = 0; i < n; i += 1) {
    const diff = observed[i] - mean;
    ssTot += diff * diff;
    const residual = observed[i] - predicted[i];
    ssRes += residual * residual;
  }
  return ssTot === 0 ? 1 : 1 - ssRes / ssTot;
};

export const percentile = (sortedValues, p) => {
  if (!sortedValues.length) return null;
  const index = (sortedValues.length - 1) * p;
  const lower = Math.floor(index);
  const upper = Math.ceil(index);
  if (lower === upper) return sortedValues[lower];
  const weight = index - lower;
  return sortedValues[lower] * (1 - weight) + sortedValues[upper] * weight;
};
